export enum ESourceFieldErrorType {
  ENUM = 'enum',
  LINKED = 'linked',
  REQUIRED = 'required'
}
